<script context="module">
    import {
        setErrorStyle,
        resetDefaultStyle,
        getAmountInCurrency,
    } from "../../../Utils/utilFunctions.svelte";

    export const addErrorInput = (id, errInputs = [], placeholder = "") => {
        setErrorStyle(id, placeholder);
        errInputs.push(id);
        return errInputs;
    };

    export const removeErrorInput = (id, errInputs = [], placeholder = "") => {
        resetDefaultStyle(id, placeholder);
        errInputs = errInputs.filter((errInput) => errInput !== id);
        return errInputs;
    };

    export const getUnderAndOverPaymentProperties = (encounter) => {
        let showUnderPayment = false,
            showOverPayment = false;
        let underPaymentTexts = [],
            overPaymentTexts = [];

        const {
            underPaidPatient,
            underPaidHealthFund,
            underPaidApprovedBy,
            underPaidApprovedByName,
        } = encounter;
        const {
            overPaidPatient,
            overPaidHealthFund,
            overPaidApprovedBy,
            overPaidApprovedByName,
        } = encounter;

        showUnderPayment = !!(underPaidPatient || underPaidHealthFund);
        showOverPayment = !!(overPaidPatient || overPaidHealthFund);

        if (underPaidPatient)
            underPaymentTexts.push({
                title: "Patient Underpaid: ",
                value: getAmountInCurrency(underPaidPatient),
            });
        if (underPaidHealthFund)
            underPaymentTexts.push({
                title: "Health Fund Underpaid: ",
                value: getAmountInCurrency(underPaidHealthFund),
            });
        if (underPaidApprovedBy)
            underPaymentTexts.push({
                title: "Approved By: ",
                value: underPaidApprovedByName,
                isApprovedBy: true,
            });

        if (overPaidPatient)
            overPaymentTexts.push({
                title: "Patient Overpaid: ",
                value: getAmountInCurrency(overPaidPatient),
            });
        if (overPaidHealthFund)
            overPaymentTexts.push({
                title: "Health Fund Overpaid: ",
                value: getAmountInCurrency(overPaidHealthFund),
            });
        if (overPaidApprovedBy)
            overPaymentTexts.push({
                title: "Approved By: ",
                value: overPaidApprovedByName,
                isApprovedBy: true,
            });

        return {
            showUnderPayment,
            showOverPayment,
            underPaymentTexts,
            overPaymentTexts,
        };
    };
</script>
